import { SaveAlt as SaveAltIcon } from '@mui/icons-material';

const Save = (): JSX.Element => <SaveAltIcon fontSize="inherit" />;

export default Save;
